import { HttpClient } from "@angular/common/http";
import { Inject } from "@angular/core";
import { HotToastService } from "@ngneat/hot-toast";
import { Observable } from "rxjs";
import { QueueMail } from "../../communication/pages/mail-modal/queue";
import { Filter, FilterWithIds } from "../components/table/sortable-table/filter-form-group";
import { BaseService } from "./base.service";

export class MailService<T, TList> extends BaseService<T, TList> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    protected override controller: string,
    protected override toast: HotToastService | null = null
  ) {
    super(http, baseUrl, controller, toast);
  }

  sendMail(recipientId: number, template: QueueMail) {
    return this.post(`/${recipientId}/mail`, template); //Todo: correct return type?
  }

  sendMailsToAll(filterFields: Filter, template: QueueMail) {
    return this.post<QueueMail, number>(
      "/all/mail?" + this.serializeForQueryStringOdata(filterFields),
      template
    );
  }

  sendMailsToSelection(filterFields: FilterWithIds, template: QueueMail): Observable<number> {
    return this.post<QueueMail, number>(
      "/all/mail?" + this.serializeForQueryStringOdata(filterFields),
      template
    );

    //const mail: QueueMailWithFilter = {
    //  ...template,
    //  Filter: filterFields,
    //};
    //return this.postCustom<number>('/all/mailfiltered', mail);
  }
}
